<template>
  <div>
    <el-dialog title="详情" :visible.sync="localVisible" width="80%" top="3vh" @close="handleClose">
      <div class="detail-info" v-loading="loading">
        <el-row :gutter="10" class="info-row">
          <el-col :span="10">
            <div class="info-item"><span class="label">专链名称：</span>{{ (detailData && detailData.name) || (rowData ?
              rowData.name : '--') }}</div>
          </el-col>
          <el-col :span="4">
            <div class="info-item"><span class="label">代理商：</span>{{ (detailData && detailData.agentName) || (rowData ?
              rowData.agentName : '--') }}</div>
          </el-col>
          <el-col :span="6">
            <div class="info-item"><span class="label">有效期：</span>{{ (detailData &&
              formatValidTime(detailData.startTime,
                detailData.endTime)) || (rowData ? rowData.validTime : '--') }}</div>
          </el-col>
          <el-col :span="4">
            <div class="info-item"><span class="label">折扣力度：</span>{{ (detailData && (detailData.discountSum ||
              detailData.discountSum === 0)) ? detailData.discountSum : '--' }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="info-row" style="margin-top: 20px;">
          <el-col :span="10">
            <div class="info-item"><span class="label">链接地址：</span>{{ (detailData && detailData.url) || (rowData ?
              rowData.link : '--') }}</div>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="handleShowQrCode">
              小程序码
            </el-button>
          </el-col>

          <el-col :span="6">
            <div class="info-item"><span class="label">专链状态：</span>{{ (detailData && getStatus(detailData.startTime,
              detailData.endTime, detailData.state)) || (rowData ? rowData.status : '--') }}</div>
          </el-col>
          <el-col :span="4">
            <div class="info-item"><span class="label">已销售数量：</span>{{ (detailData && (detailData.sumCommodityCount ||
              0))
              }}</div>
          </el-col>
        </el-row>
      </div>

      <!-- 表格部分 -->
      <div class="table-container">
        <el-table :data="tableData" style="width: 100%" border v-loading="loadingList" max-height="600">
          <el-table-column v-for="col in columns" :key="col.prop" :prop="col.prop" :label="col.label"
            :min-width="col.minWidth" align="center"></el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination-wrap" v-if="page.total > 0">
          <el-pagination @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size"
            layout="total, prev, pager, next" :total="page.total" class="pagination-center">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 小程序码弹窗 -->
    <el-dialog title="小程序码" :visible.sync="qrCodeVisible" width="400px" append-to-body>
      <div style="text-align: center;">
        <el-image :src="qrCodeUrl" style="width: 300px; height: 300px;" fit="contain">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
            <p>小程序码加载失败</p>
          </div>
        </el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { commodityAgentDetail, commodityAgentOrderListByAgentId } from '@/common/api'
export default {
  name: 'DetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      localVisible: this.visible,
      loading: false,
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      columns: [
        { label: '用户ID', prop: 'userId', minWidth: '100' },
        { label: '用户名称', prop: 'receiverName', minWidth: '120' },
        { label: '商品名称', prop: 'commodityName', minWidth: '220' },
        { label: '购买时间', prop: 'payTime', minWidth: '160' },
        { label: '购买数量', prop: 'oneCommodityCount', minWidth: '100' },
        { label: '支付金额', prop: 'price', minWidth: '120' }
      ],
      detailData: null,
      qrCodeVisible: false,
      loadingList: false
    };
  },
  computed: {
    qrCodeUrl() {
      if (this.rowData && this.rowData.imageUrl) {
        // 拼接当前服务器地址
        // const origin = window.location.origin;
        const origin = 'https://static.lienjang.cn/cloud';
        // const origin = 'http://192.168.3.19:1819/cloud';
        console.log('origin', origin + this.rowData.imageUrl)
        return origin + this.rowData.imageUrl;
      }
      return '';
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val;
      if (val && this.rowData) {
        this.fetchDetailData();
        this.getCommodityAgentOrderListByAgentId();
      } else {
        // 关闭时重置
        this.tableData = [];
        this.detailData = null;
        this.page.current = 1;
        this.page.total = 0;
      }
    },
    localVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  methods: {
    handleClose() {
      this.localVisible = false;
    },
    fetchDetailData() {
      this.loading = true;
      commodityAgentDetail({
        id: this.rowData.id
      }).then(res => {
        if (res.code === 0 && res.data) {
          this.detailData = res.data;
        }
      }).catch(err => {
        this.tableData = [];
        this.page.total = 0;
      }).finally(() => {
        this.loading = false;
      })

    },
    getCommodityAgentOrderListByAgentId() {
      this.loadingList = true;
      commodityAgentOrderListByAgentId({
        pageNum: this.page.current,
        pageSize: this.page.size,
        id: this.rowData.id
      }).then(res => {
        if (res.code === 0 && res.data) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      }).catch(err => {
        this.tableData = [];
        this.page.total = 0;
      }).finally(() => {
        this.loadingList = false;
      })
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getCommodityAgentOrderListByAgentId();
    },
    handleShowQrCode() {
      if (this.rowData && this.rowData.imageUrl) {
        this.qrCodeVisible = true;
      } else {
        this.$message.warning('暂无小程序码');
      }
    },
    getStatus(startStr, endStr, state) {
      if (!startStr || !endStr) return '未知';
      const now = new Date().getTime();
      const start = new Date(startStr.replace(/-/g, '/')).getTime();
      const end = new Date(endStr.replace(/-/g, '/')).getTime();
      if (state === 2) return '已取消';
      if (now < start) return '待生效';
      if (now > end) return '已过期';
      return '生效中';
    },
    formatValidTime(startStr, endStr) {
      if (!startStr || !endStr) return '';
      const format = (str) => str.substring(0, 10).replace(/-/g, '.');
      return `${format(startStr)}-${format(endStr)}`;
    }
  }
};
</script>

<style scoped>
.detail-info {
  margin-bottom: 24px;
}

.info-row {
  margin-bottom: 12px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-item {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  word-break: break-all;
}

.info-item .label {
  color: #888;
  white-space: nowrap;
}

.table-container {
  margin-top: 10px;
}

.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
